<h2 class="fw:regular c:blue-700 m-8:t m-16:b md:m-48:t md:m-24:b">Versicherte Geräte</h2>
<div class="widget-list">
    @for (device of devices(); track device.Id) {
        <app-b2b-insured-device
            [device]="device"
            (updateDevice)="submit($event)"
        ></app-b2b-insured-device>
    }
</div>
